import { render, staticRenderFns } from "./button-group-field.vue?vue&type=template&id=3a81d4ea&scoped=true&"
import script from "./button-group-field.vue?vue&type=script&lang=js&"
export * from "./button-group-field.vue?vue&type=script&lang=js&"
import style0 from "./button-group-field.vue?vue&type=style&index=0&id=3a81d4ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a81d4ea",
  null
  
)

export default component.exports